import './src/ui/styles/global.css'
import './src/lib/dayJsConfig'
import React from 'react'
import { rootWrapper } from './gatsby-wrapper'
import type { GatsbyBrowser } from 'gatsby'

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = rootWrapper
